import React, {FC} from "react";
import {isFundRaising, isLoanPayment, isOverdue, isPaid, isRefunded, Money, OwnedProject} from "api-client";
import {Money as MoneyComponent} from "components/common";
import {Button} from "../../../../../common";
import styles from '../../MyOwnedProject.module.scss';

interface ProgressSectionProps {
  project: OwnedProject;
  progress: number;
  onShowSchedule: () => void;
}

interface ProgressConfig {
  leftLabel: string;
  rightLabel: string | null;
  showButton: boolean;
  show: boolean;
}

const getProgressConfig = (project: OwnedProject): ProgressConfig => {
  if (isFundRaising(project.status)) {
    return {
      leftLabel: "Собрано",
      rightLabel: "Осталось собрать",
      showButton: false,
      show: true
    };
  }

  if (isLoanPayment(project.status)) {
    return {
      leftLabel: "Выплачено",
      rightLabel: "Осталось выплатить",
      showButton: true,
      show: true
    };
  }

  if (isPaid(project.status)) {
    return {
      leftLabel: "Выплачено",
      rightLabel: null,
      showButton: false,
      show: true
    };
  }

  if (isOverdue(project.status)) {
    return {
      leftLabel: "Выплачено",
      rightLabel: "Остаток займа",
      showButton: true,
      show: true
    };
  }

  if (isRefunded(project.status)) {
    return {
      leftLabel: "",
      rightLabel: null,
      showButton: false,
      show: false
    };
  }

  // Default
  return {
    leftLabel: "Собрано",
    rightLabel: "Осталось собрать",
    showButton: false,
    show: true
  };
};

export const ProgressSection: FC<ProgressSectionProps> = ({project, progress, onShowSchedule}) => {
  const config = getProgressConfig(project);

  if (!config.show) {
    return null;
  }

  return (
    <div className={styles.myOwnedProject__progressSectionContainer}>
      <section className={`${styles.myOwnedProject__progressSection} ${
        styles[`myOwnedProject__progressSection__${project.status}`] || ""
      }`}>
        <div className={styles.myOwnedProject__progressTrack}>
          <div
            className={`${styles.myOwnedProject__progressFill} ${
              styles[`myOwnedProject__progressFill__${project.status}`] || ""
            }`}
            style={{width: `${progress}%`}}
          />
        </div>

        <div className={styles.myOwnedProject__progressRow}>
          <div className={styles.myOwnedProject__progressColumn}>
            <div className={styles.myOwnedProject__rowHeader}>{config.leftLabel}</div>
            <MoneyComponent money={project.investedSum} />
          </div>
          {config.rightLabel && (
            <div className={styles.myOwnedProject__progressColumnRight}>
              <div className={styles.myOwnedProject__rowHeader}>{config.rightLabel}</div>
              <MoneyComponent money={new Money(project.targetSum?.amount - project.investedSum?.amount, project.targetSum?.currencyCode)} />
            </div>
          )}
        </div>
      </section>

      {config.showButton && (
        <div className={styles.myOwnedProject__buttonContainer}>
          <Button className={`${styles.myOwnedProject__buttonPaymentSchedule} ${
            styles[`myOwnedProject__buttonPaymentSchedule__${project.status}`] ?? ""
          }`} onClick={onShowSchedule}>
            Смотреть график
          </Button>
        </div>
      )}
    </div>
  );
};








